import React from 'react';
import styled from 'styled-components';
import { TextColor } from 'styles/Global/colorSemantic';
import { Body5Regular } from 'styles/Global/typography';

const MobileCopyright = () => {
    const version = require('../../../package.json').version;

    return <CopyrightNotice>Copyright ⓒTLC Healthcare. All rights reserved. (v{version})</CopyrightNotice>;
};

export default MobileCopyright;

const CopyrightNotice = styled.span`
    display: flex;
    justify-content: center;
    align-items: center;
    color: ${TextColor.color_text_disabled};
    font-weight: 400;
    font-size: 10px;
    width: 100%;
    height: 100%;
`;
